import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { BodyPrimary } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    resendEmail: Function;
};

const ForgotPasswordConfirm = ({ resendEmail }: Props) => {
    return (
        <ContentWrapper>
            <SubHeader>
                <FormattedMessage id="forgotPasswordConfirmation.text" />
            </SubHeader>
            <BodyPrimary>
                <FormattedMessage
                    id="forgotPasswordConfirmation.help"
                    values={{
                        link: (
                            <Link
                                key="forgot-password-confirm-link"
                                onClick={resendEmail}
                            >
                                <FormattedMessage id="forgotPasswordConfirmation.helpLink" />
                            </Link>
                        ),
                    }}
                />
            </BodyPrimary>
        </ContentWrapper>
    );
};

export default ForgotPasswordConfirm;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
`;

const SubHeader = styled(BodyPrimary)`
    margin-bottom: 24px;
`;
